import { Divider, Modal } from "@mui/material";
import { PricingDefinition } from "./pricingDefinitions";
import {
	PricingDefinitionModalContent,
	PricingDefinitionModalDefinition,
	PricingDefinitionModalDefinitionList,
	PricingDefinitionModalWrapper
} from "./PricingDefinitionModal.styles";
import { PricingDefinitionsSubheaderText, PricingDefinitionsText } from "constants/text";
import { DialogTitle } from "../../Dialog";

interface PricingDefinitionModalProps {
	isOpen: boolean;
	toggleModal: () => void;
	pricingDefinitions: PricingDefinition[];
	dataTestIdPrefix?: string;
}

const PricingDefinitionModal = ({
	isOpen,
	toggleModal,
	pricingDefinitions,
	dataTestIdPrefix
}: PricingDefinitionModalProps) => {
	return (
		<Modal
			open={isOpen}
			onClose={toggleModal}
		>
			<PricingDefinitionModalWrapper data-testid={`${dataTestIdPrefix}-pricing-definition-modal`}>
				<DialogTitle
					title={PricingDefinitionsText}
					handleClose={toggleModal}
				/>
				<PricingDefinitionModalContent>
					<span>{PricingDefinitionsSubheaderText}</span>
					<Divider />
					<PricingDefinitionModalDefinitionList>
						{pricingDefinitions.map((def) => (
							<PricingDefinitionModalDefinition key={def.title}>
								<div>
									<span>{def.title}</span>
									{def.clarifier && <span>{def.clarifier}</span>}
								</div>
								<span>{def.definition}</span>
							</PricingDefinitionModalDefinition>
						))}
					</PricingDefinitionModalDefinitionList>
				</PricingDefinitionModalContent>
			</PricingDefinitionModalWrapper>
		</Modal>
	);
};

export default PricingDefinitionModal;
